import { getDeviceInfo } from '@tencent/wetv-utils';
import wetvKernel from '@tencent/wetv-kernel';
import { reportEvent } from './util';
import { assessDeviceCapability } from './deviceAssessment';

const deviceDataReport = () => {
  const fullInfo = getDeviceInfo({
    needDevice: true,
    needFeatures: true,
    needPerformance: true,
    forceRefresh: true,
  });
  const { offlineLog } = wetvKernel;
  const logger = offlineLog.logger('fetcher');
  try {
    logger?.log(`[getDeviceInfo][fullInfo:${JSON.stringify(fullInfo)}]`);
  } catch(e) {
    logger?.error('[offlineLog.logger Log serialization failed]');
  }
  reportEvent({
    name: 'device_info_report',
    ext3: fullInfo,
  });
  assessDeviceCapability({
    onError: (error) => {
      console.error('assessDeviceCapability Error:', error);
    },
    testNetworkUrls: [
      'https://static.wetv.vip/static/media/logo.png',
    ],
  }).then((result) => {
    console.log('device_assessment_report', result);
    reportEvent({
      name: 'device_assessment_report',
      ext3: result,
    });
  });
};

export { deviceDataReport };
